<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$store.state.isAuthenticated"
    >
      <v-list dense>
        <v-list-item-group color="secondary">
            <v-list-item link to="/">
                <v-list-item-action>
                    <v-icon>mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Status</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/free-status-text">
                <v-list-item-action>
                    <v-icon>mdi-card-text</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Vrije teksten</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/platform-control" class="active">
                <v-list-item-action>
                    <v-icon>mdi-toggle-switch</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Perron bediening</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/platform-preferences">
                <v-list-item-action>
                    <v-icon>mdi-bus-stop</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Voorkeur perrons</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
           </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      v-if="$store.state.isAuthenticated"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>QA-admin</v-toolbar-title>
    </v-app-bar>
    <v-content>
        <v-container
            fluid>
                
            <v-row
            align="start"
            justify="center"
            >
                <router-view></router-view>
            </v-row>
        </v-container>

    </v-content>

  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },

    data: () => ({
      drawer: null,
    }),
  }
</script>